import { 
    TOGGLE_SIDEBAR, 
    TOGGLE_BOOKING 
} from '../planner/planner.action'

import { 
    ACTIVATE_LEG,
    ACTIVATE_LEG_BY_HASHTAG,
    ADD_LEG 
} from '../leg/leg.action.js'

import {
    ACTIVATE_MENU_ITEM
} from '../appfooter/appfooter.action.js'

import {
    CHANGE_DETAILS_UI,
    ACTIVATE_ACCOMMODATION,
    ACTIVATE_ACTIVITY,
    ACTIVATE_ACTIVITY_BY_ID,
    ACTIVATE_ACCOMMODATION_BY_ID,
    ACTIVATE_TRAVEL
} from '../details/details.action.js'

export default (state, action) => {
    let activeLeg
  
    switch (action.type)   {
        case ACTIVATE_LEG:
            return state.set('activeLeg', action.leg ? action.leg.get('id') : null)
            document.body.scrollTop = document.documentElement.scrollTop = 0
        case ACTIVATE_LEG_BY_HASHTAG:
            activeLeg = state.get('activeLeg')
            document.body.scrollTop = document.documentElement.scrollTop = 0
            if (activeLeg === action.legId) {
                return state.set('activeLeg', null)
            } else {
                return state.set('activeLeg', action.legId)
            }
        case ADD_LEG:
            document.body.scrollTop = document.documentElement.scrollTop = 0
            return state.set('activeLeg', action.leg.get('id'))
        case TOGGLE_SIDEBAR:
            let sidebarShown = state.get('sidebarActive')

            if (sidebarShown === true) {
                state = state.set('sidebarActive', false)
            } else {
                state = state.set('sidebarActive', true)
            }

            return state
        case TOGGLE_BOOKING:
            document.body.scrollTop = document.documentElement.scrollTop = 0
            let bookingShown = state.get('bookingActive')
            state = state.set('bookingActive', !bookingShown)
            $('.copyright-notices').toggle(bookingShown)

            return state
        case ACTIVATE_MENU_ITEM:

            let oldActiveMenuItem = state.get('activeMenuItem')
            let sidebarActive = state.get('sidebarActive')

            if (oldActiveMenuItem === action.selectedMenuItem && sidebarActive) {
                state = state.set('activeMenuItem', '')
                return state.set('sidebarActive', false)
            }

            // if there's a new active item, use that
            if (action.selectedMenuItem) {
                state = state.set('activeMenuItem', action.selectedMenuItem)
            }

            let activeMenuItem = state.get('activeMenuItem')

            // if there's no old or new active menu item, use default
            if (!activeMenuItem) {
                // default active item
                state = state.set('activeMenuItem', '')
            }

            if (!sidebarActive) {
                state = state.set('sidebarActive', true)
            }

            return state
        case CHANGE_DETAILS_UI:
            document.body.scrollTop = document.documentElement.scrollTop = 0
            state = state.set('detailSection', action.detailSection)
            state = state.set('detailSubSection', action.detailSubSection)
            state = state.set('detailSubDetail', action.detailSubDetail)
            return state
        case ACTIVATE_ACCOMMODATION:
            document.body.scrollTop = document.documentElement.scrollTop = 0
            state = state.set('activeAccommodation', action.accommodation)
            return state
        case ACTIVATE_ACTIVITY:
            document.body.scrollTop = document.documentElement.scrollTop = 0
            state = state.set('activeActivity', action.activity)
            return state
        case ACTIVATE_ACTIVITY_BY_ID:
            document.body.scrollTop = document.documentElement.scrollTop = 0
            state = state.set('activeActivityId', action.activity_id)
            return state
        case ACTIVATE_ACCOMMODATION_BY_ID:
            document.body.scrollTop = document.documentElement.scrollTop = 0
            state = state.set('activeAccommodationId', action.accommodation_id)
            return state      
        case ACTIVATE_TRAVEL:
            document.body.scrollTop = document.documentElement.scrollTop = 0
            state = - state.set('activeTravel', action.travel)
            return state
        default:
            return state
    }
}
